import { useDispatch } from 'react-redux';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { useResolveRoute } from '@mews/routing';
import { RouteName } from '@mews-commander/enums';
import { navigateInModal } from '../../app/actions/common';

export const useCopyEnterprise = () => {
    const dispatch = useDispatch();
    const resolveRoute = useResolveRoute();

    return useRepositoryMutation('enterpriseBuilder', 'export', {
        onSuccess: () => {
            showSuccessAlert({
                title: lt('QueueItemCreated'),
                description: lt('QueueItemCreatedDescription'),
            });
            dispatch(navigateInModal(resolveRoute(RouteName.EnterpriseBuilderQueueItemsIndex)));
        },
    });
};
